enum ManageCourseSessionsMode {
  AddToCart = 'AddToCart',
  UpdateInCart = 'UpdateInCart',
  EditRegistration = 'EditRegistration',
}
export default ManageCourseSessionsMode;
